import { forwardRef, type CSSProperties } from "react";

export type SlashMenuDescriptionProps = {
	description: string;
	style: CSSProperties;
};

export const SlashMenuDescription = forwardRef<HTMLDivElement, SlashMenuDescriptionProps>(
	({ description, style }, ref) => {
		return (
			<div
				ref={ref}
				style={style}
				className="z-50 max-w-xs rounded-md bg-foreground px-3 py-2 text-xs leading-relaxed text-background shadow-lg"
				role="tooltip"
			>
				{description}
			</div>
		);
	},
);
